export default __webpack_public_path__ + "static/media/copy.73daab84.svg";